/*
 * @Author: wzh
 * @LastEditTime: 2024-12-17 17:59:00
 * @Description: 认证 store
 */
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";

import { authAPI } from "@/apis";
import router from "@/router";
import VueCookies from "vue-cookies";
import { UseLoading } from "@/utils/decorators";
import { LocalStorageItem, SessionStorageItem } from "@/utils/storage";
import { delAllCookie } from "@/utils/index";
// 创建 storage 管理器
const tokenLSI = new LocalStorageItem({ fieldName: "token" });
const userLSI = new LocalStorageItem({ fieldName: "user", jsonify: true });
// 创建 session 管理器
const tokenSSI = new SessionStorageItem({ fieldName: "token" });
const userSSI = new SessionStorageItem({ fieldName: "user", jsonify: true });

function resolveCookieDomains() {
  const host = window.location.hostname || "";
  const domains = [""];
  const isIpv4 = /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
  if (!host || host === "localhost" || isIpv4 || host.indexOf(".") === -1) {
    return domains;
  }
  domains.push(`.${host}`);
  const parts = host.split(".");
  if (parts.length > 2) {
    domains.push(`.${parts.slice(-2).join(".")}`);
  }
  return Array.from(new Set(domains));
}

function clearCookieByName(name) {
  const domains = resolveCookieDomains();
  domains.forEach((domain) => {
    const domainPart = domain ? `; domain=${domain}` : "";
    document.cookie = `${name}=; path=/${domainPart}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
}

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  // 令牌
  _token = tokenLSI.get() || tokenSSI.get();

  // 用户信息
  _user = userLSI.get() || userSSI.get();

  get token() {
    return this._token;
  }

  get user() {
    return this._user;
  }

  @Mutation
  setToken(token) {
    this._token = token;
  }
  @Mutation
  setSessionToken(token) {
    tokenLSI.set(token);
    tokenSSI.set(token);
  }

  @Mutation
  setUser(user) {
    this._user = user;
  }
  @Mutation
  setSessionUser(user) {
    userLSI.set(user);
    userSSI.set(user);
  }

  @Mutation
  removeToken() {
    this._token = null;
    tokenLSI.remove();
    tokenSSI.remove();
  }

  @Mutation
  removeUser() {
    this._user = {};
    userLSI.remove();
    userSSI.remove();
  }

  // 登录
  @Action()
  // @UseLoading('正在登录...')
  async login(formInline) {
    // 登录并保存 token
    const res = await authAPI.login(formInline);
    return res;
  }
  // 退出登录
  @Action()
  async loginOut(param) {
    let redirect_uri = sessionStorage.getItem("REDIRECT_URI");

    //移除token ,用户信息
    this.context.commit("setUser", {});
    this.context.commit("setToken", "");
    let language = localStorage.getItem("language");
    localStorage.clear();
    if (language) {
      localStorage.setItem("language", language);
    }
    sessionStorage.clear();
    let arr = VueCookies.keys();
    arr.forEach((el) => {
      VueCookies.remove(el);
    });
    ["REMEMBER_ME", "congress", "token", "user"].forEach((name) =>
      clearCookieByName(name)
    );
    delAllCookie();
    const res = await authAPI.logout();
    if (param) {
      location.href = param;
    } else {
      if (redirect_uri)
        router.replace({
          path: "/authserver/login",
          query: { redirect_uri: redirect_uri },
        });
      else router.replace({ path: "/authserver/login" });
    }
  }
}
